export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13695.d6fc2f00.jpg";